import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconTags({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M11.572 1.1a.5.5 0 0 1 .509.427l.681 4.633a.5.5 0 0 1-.112.394l-5.175 6.168a.5.5 0 0 1-.704.061l-5.362-4.5a.5.5 0 0 1-.062-.704l5.175-6.167a.5.5 0 0 1 .369-.178l4.68-.134zm1.498.282A1.5 1.5 0 0 0 11.543.1l-4.68.133A1.5 1.5 0 0 0 5.755.77L.581 6.937A1.5 1.5 0 0 0 .766 9.05l5.362 4.5a1.5 1.5 0 0 0 2.113-.185l5.175-6.168a1.5 1.5 0 0 0 .335-1.182l-.681-4.633zm-2.483 2.614a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/>
        </svg>
    );
}

export default IconTags;
